/**
 * Tracks a Snowplow self-describing event.
 * @param {object} primaryEvent - The main event object { schema: string, data: object }.
 * @param {Array<object>} [contexts=[]] - An array of context objects [{ schema: string, data: object }].
 */
export function trackCustomSnowplowEvent(primaryEvent, contexts = []) {
    if (!primaryEvent) {
        console.warn('No primary event provided. Event not sent.');
        return;
    }

    const validContexts = contexts.filter(context => context !== null && context !== undefined);

    if (typeof window !== 'undefined' && window.snowplow && typeof window.snowplow === 'function') {
        window.snowplow('trackSelfDescribingEvent', {
            event: primaryEvent,
            context: validContexts
        });
    } else {
        console.warn('Snowplow tracker not available or not a function. Event not sent:', { primaryEvent, contexts });
    }
}


/**
 * Tracks a page view event with optional contexts.
 * @param {object} params - Parameters for the page view event.
 * @param {string} params.page_url - The URL of the page being viewed.
 * @param {string} params.page_title - The title of the page.
 * @param {Array<object>} [params.contexts=[]] - An array of context objects [{ schema: string, data: object }].
 * @param {number} [params.true_timestamp] - The true timestamp in milliseconds (optional).
 */
export function trackPageView({ page_url = window.location.href, page_title = document.title, contexts = [], true_timestamp }) {
    const validContexts = contexts.filter(context => context !== null);

    if (validContexts.length === 0) {
        console.warn('No valid contexts provided. Page view not tracked:', { page_url, page_title, contexts });
        return;
    }

    if (typeof window !== 'undefined' && window.snowplow && typeof window.snowplow === 'function') {
        window.snowplow('trackPageView', {
            title: page_title,
            context: validContexts,
        });
    } else {
        console.warn('Snowplow tracker not available or not a function. Page view not tracked:', { page_url, page_title, contexts });
    }
}